import { render, staticRenderFns } from "./integral_center.vue?vue&type=template&id=010a2c26&scoped=true&"
import script from "./integral_center.vue?vue&type=script&lang=js&"
export * from "./integral_center.vue?vue&type=script&lang=js&"
import style0 from "./integral_center.vue?vue&type=style&index=0&id=010a2c26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a2c26",
  null
  
)

export default component.exports